import _, {isArray, isEqual} from 'lodash';


// field Reducer helper
export const fieldReducer = (oldState, actions) => {

    //console.log('reducing...');
    actions = isArray(actions) ? actions : [actions];
    const newState = Object.assign({},oldState);
    let changed = false;

    actions.forEach( (action) => {
        if (action.type !== 'forceUpdate' && !(action.field in oldState)) {
            // i.e. Only support fields in initial state
            throw new Error("Unknown field: "+action.field);  // todo ?option to just append ?Arrays
        }

        switch (action.type) {
            case 'forceUpdate':
                changed = true;
                break;
            case 'remove':
                if (newState[action.field].includes(action.value)) {
                    newState[action.field] = newState[action.field].filter(tag => tag !== action.value);
                    changed = true;
                }
                break;
            case 'add':
                if (!newState[action.field].includes(action.value)) {
                    newState[action.field] = newState[action.field].concat([action.value]);
                    changed = true;
                }
                break;
            case 'replace':
                // Todo use compareArray compareObject?
                if (newState[action.field] !== action.value) {
                    newState[action.field] = action.value;
                    changed = true;
                }
                break;
            default:
                throw new Error("Unspported reducer action");
        }
    });

    return changed ? newState : oldState;
};

// will just attempt to replace any values in the oldState with all values from the newState
// so sub structures will trigger change (unless the are the underlying ref)
export function objectReplaceReducer(oldState={}, newState={})
{
    if (! isEqual(Object.keys(newState).sort(), Object.keys(oldState).sort() ) ){
        return newState;
    }

    return fieldReducer(oldState,
        Object.keys(newState)
            .map((field)=>{
                return {
                    type:'replace',
                    field,
                    value:newState[field]
                };
            })
    );
}


// could by lodash ext
//_.mixin({
//    toArrayFromObj: function (object, keyName)
export function toArrayFromObj (object, keyName)
{
    return _(object).keys().map(function (item)
    {
        object[item][keyName] = item;
        return object[item];
    }).value();
}

// clean up Ad Seller types & cataegories
export function extractKeywords(type) {
    return type.replace(/\b(Firm|Company|Contractor|Service|Shop|Store|Provider|Club|Center|market|for|or|&|\(|\)|and|Agency|Facility|Business|Related|Dealer|\/)(es|s)?\b/gi, '').replace(/\s+/g,' ');
}